require('./flapper.js');
require('odometer');

import CanvasVideoPlayer from './canvas-video-player.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

jQuery(function() {
  
  /*
  |--------------------------------------------------------------------------
  | BAM LeadTracker Preview
  |--------------------------------------------------------------------------
  */

  var laptopScreen = document.getElementById('bamlt-preview-screenshot');
  var scrollAnimation = gsap.timeline({
    scrollTrigger: {
      trigger: '#bamlt-preview',
      start: "top 75%",
      scrub: true,
    }
  });

  scrollAnimation.to(laptopScreen, 0.5, { top: 0 });


  window.odometerOptions = {
    auto: false,
    duration: 4000
  }
  var started = false;
  var tsStart = 1556026613000; // 2019-04-23
  var leadsSinceStart = Math.ceil(((Date.now() - tsStart) / 1000) / 4); // approx. 1 lead every 4 seconds
  var numLeads = 4300001 + parseInt(leadsSinceStart);

  // Start initial animation at 16,051 fewer
  // than the current total.
  jQuery('.odometer').text(numLeads - 16051);

  ScrollTrigger.create({
    trigger: '#bamlt-preview',
    start: "top 80%",
    onEnter: function() {
      if (started) {
        return;
      }
      started = true;

      jQuery('.odometer').fadeIn('slow').text(numLeads);

      setInterval(function() {
        jQuery('.odometer').text(++numLeads);
      }, 4000);
    }
  });

  /*
  |--------------------------------------------------------------------------
  | Capabilities
  |--------------------------------------------------------------------------
  */

  var capabilities = [
    'Strategy',
    'Creative Planning',
    'Paid Search',
    'SEO',
    'Email Marketing',
    'Community Management',
    'Fly Swatting',
    'Media Buying',
    'Web Development',
    'Custom Technology',
    'Dog Sitting',
    'Billboards'
  ];

  var curCapability = 0;
  var curCapability2 = 4;
  var curCapability3 = 2;
  var curCapability4 = 7;
  var maxLength = 0;
  for (var i = 0; i < capabilities.length; i++) {
    if (capabilities[i].length > maxLength) {
      maxLength = capabilities[i].length;
    }
  }

  jQuery('#capabilities-display').flapper({
    width: maxLength
  });
  jQuery('#capabilities-display2').flapper({
    width: maxLength
  });
  jQuery('#capabilities-display3').flapper({
    width: maxLength
  });
  jQuery('#capabilities-display4').flapper({
    width: maxLength
  });

  changeFlapper();
  setInterval(function() {
    changeFlapper();
  }, 3000);

  function changeFlapper() {
    if (curCapability >= capabilities.length - 1) {
      curCapability = 0;
    } 
    else {
      curCapability++;
    }

    if (curCapability2 >= capabilities.length - 1) {
      curCapability2 = 0;
    }
    else {
      curCapability2++;
    }

    if (curCapability3 >= capabilities.length - 1) {
      curCapability3 = 0;
    }
    else {
      curCapability3++;
    }

    if (curCapability4 >= capabilities.length - 1) {
      curCapability4 = 0;
    }
    else {
      curCapability4++;
    }

    var capability = capabilities[curCapability].toUpperCase();
    jQuery('#capabilities-display').val(capability).change();

    var capability2 = capabilities[curCapability2].toUpperCase();
    jQuery('#capabilities-display2').val(capability2).change();

    var capability3 = capabilities[curCapability3].toUpperCase();
    jQuery('#capabilities-display3').val(capability3).change();

    var capability4 = capabilities[curCapability4].toUpperCase();
    jQuery('#capabilities-display4').val(capability4).change();
  }

});
